import nav from './nav';
import PLANS from './plans';
import findInPage from './findInPage';

export default {
  nav,
  findInPage,
  PLANS,
};
